/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum BillingLineItemsOptionalFields {
    availability_zone = 'availability_zone',
    billing_entity = 'billing_entity',
    meter_sub_category = 'meter_sub_category',
    pricing_category = 'pricing_category',
    pricing_purchase_option = 'pricing_purchase_option',
    product_category = 'product_category',
    product_family = 'product_family',
    product_service_code = 'product_service_code',
    product_sku = 'product_sku',
    publisher = 'publisher',
    resource_category = 'resource_category',
    resource_group = 'resource_group',
    resource_id = 'resource_id',
    resource_name = 'resource_name',
    resource_operation = 'resource_operation'
}
